import React, { useEffect, useState } from 'react';
import Navbar from "../../components/Features/Navbar";
import hr from "./../../images/icons/hr.png";
import { Box, CircularProgress, Container } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card, Row, Col } from 'react-bootstrap';
import Footer from '../../components/Home/Footer';
import { Fade } from 'react-awesome-reveal';
import LogoExpertCo from './../../images/logos/LogoExpertConnection.png';
import LogoInfoCo from './../../images/logos/LogoInfoConnection.png';
import LogoSportConnection from './../../images/logos/LogoSportConnection.png';
import StrapiRichText from '../../components/StrapiRichText';
import { NOTRE_HISTOIRE_DEFAULTS } from '../../content/notreHistoireFallbacks';
import { fetchNotreHistoireFromStrapi } from '../../services/strapiNotreHistoire';
import { pickCmsText, pickCmsTitle } from '../../utils/cmsContent';

const NotreHistoire = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (content?.title) {
      document.title = `${content.title} | Tsahal Connection`;
    } else {
      document.title = 'Notre Histoire | Tsahal Connection';
    }
  }, [content?.title]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const remote = await fetchNotreHistoireFromStrapi();
        if (cancelled) return;
        const d = NOTRE_HISTOIRE_DEFAULTS;
        setContent({
          title: pickCmsTitle(remote?.title, d.title),
          intro: pickCmsText(remote?.intro, d.intro),
          cardInfoConnection: pickCmsText(remote?.cardInfoConnection, d.cardInfoConnection),
          cardSportConnection: pickCmsText(remote?.cardSportConnection, d.cardSportConnection),
          cardExpertConnection: pickCmsText(remote?.cardExpertConnection, d.cardExpertConnection),
          closing: pickCmsText(remote?.closing, d.closing),
        });
      } catch {
        if (!cancelled) {
          const d = NOTRE_HISTOIRE_DEFAULTS;
          setContent({
            title: d.title,
            intro: d.intro,
            cardInfoConnection: d.cardInfoConnection,
            cardSportConnection: d.cardSportConnection,
            cardExpertConnection: d.cardExpertConnection,
            closing: d.closing,
          });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || !content) {
    return (
      <div>
        <Navbar />
        <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '40vh', alignItems: 'center' }}>
          <CircularProgress sx={{ color: '#1398aa' }} />
        </Box>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <Fade triggerOnce>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: '2rem' }}>
          <h1 style={{ fontFamily: 'Montserrat', fontWeight: '700', textAlign: 'center' }}>{content.title}</h1>
          <img src={hr} alt="" width="80" height="50" />
        </div>
        <Container maxWidth="md" style={{ marginTop: '3rem' }}>
          <StrapiRichText source={content.intro} sx={{ fontSize: '20px' }} />
        </Container>
        <Container className="d-flex justify-content-center align-items-center" style={{ marginTop: '3rem', marginBottom: '7rem' }}>
          <Row>
            <Col lg={4} style={{ marginTop: '2rem' }}>
              <Card className="shadow h-100 mb-3" style={{ borderRadius: '20px', borderColor: '#f0f0f0' }}>
                <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                  <img src={LogoInfoCo} alt="" width="200" height="200" style={{ marginBottom: '40px', marginTop: '20px' }} />
                  <Card.Text as="div" style={{ marginRight: '3rem', marginLeft: '3rem', marginBottom: '50px' }}>
                    <StrapiRichText
                      source={content.cardInfoConnection}
                      sx={{ fontSize: '16px', textAlign: 'center', '& p': { marginBottom: 0 } }}
                    />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} style={{ marginTop: '2rem' }}>
              <Card className="shadow h-100 mb-3" style={{ borderRadius: '20px', borderColor: '#f0f0f0' }}>
                <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                  <img src={LogoSportConnection} alt="" width="200" height="200" style={{ marginBottom: '40px', marginTop: '20px' }} />
                  <Card.Text as="div" style={{ marginRight: '4rem', marginLeft: '4rem', marginBottom: '50px' }}>
                    <StrapiRichText
                      source={content.cardSportConnection}
                      sx={{ fontSize: '16px', textAlign: 'center', '& p': { marginBottom: 0 } }}
                    />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} style={{ marginTop: '2rem' }}>
              <Card className="shadow h-100 mb-3" style={{ borderRadius: '20px', borderColor: '#f0f0f0' }}>
                <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                  <img src={LogoExpertCo} alt="" width="200" height="200" style={{ marginBottom: '40px', marginTop: '20px' }} />
                  <Card.Text as="div" style={{ marginRight: '4rem', marginLeft: '4rem', marginBottom: '50px' }}>
                    <StrapiRichText
                      source={content.cardExpertConnection}
                      sx={{ fontSize: '16px', textAlign: 'center', '& p': { marginBottom: 0 } }}
                    />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <Container maxWidth="md" style={{ marginTop: '3rem', marginBottom: '4rem' }}>
          <StrapiRichText source={content.closing} sx={{ fontSize: '20px', marginTop: '1rem' }} />
        </Container>
        <Footer />
      </Fade>
    </div>
  );
};

export default NotreHistoire;
